import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KMDGameMode} from "../server/KMDGameMode";
import {KMDGameAssets} from "../KMDGameAssets";
import {WIN_CAP_MODES} from "../server/IKMDData";
import {KMDSound} from "../sound/KMDSound";

export class KMDWinCap extends PIXI.Container {

    private _countUpAnim: PIXI.spine.Spine;
    private _animBg: PIXI.spine.Spine;
    private _anim: PIXI.spine.Spine;
    private _oldFilm: PIXI.spine.Spine;
    private _winTimesXLeft: PIXI.BitmapText;
    private _winTimesContainer: PIXI.Container;
    private _beefyDanceTl: gsap.core.Timeline;
    private _winTimesTl: gsap.core.Timeline;
    private _button: ContinueButton;
    private _clickCallback: () => void;

    constructor() {
        super();
        this.name = "KMDWinCap";

        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public playWinCap(cb: () => void): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            winAmount: number = KennethMustDie.model.gameData.accumulatedRoundWin,
            duration: number = 14,
            useTotalWin: boolean = (KennethMustDie.model.gameData.mode !== KMDGameMode.NORMAL || KennethMustDie.model.gameData.nextMode !== KMDGameMode.NORMAL),
            switchDuration: number = 0.5;

        this._countUpAnim.alpha = KennethMustDie.winCapCountUp.alpha = 0;

        // #476
        if (KennethMustDie.model.gameData.playedCapMode === WIN_CAP_MODES.CAP_MODE_STANDARD) {
            this._winTimesXLeft.fontSize = 30;
            this._winTimesXLeft.text = "69";
            this._winTimesXLeft.rotation = Math.PI / 2;
            this._winTimesXLeft.position.set(-80, 30);
        } else {
            this._winTimesXLeft.fontSize = 32;
            this._winTimesXLeft.text = "10";
            this._winTimesXLeft.rotation = 0;
            this._winTimesXLeft.position.set(-132, 0);
        }

        tl.to([this._countUpAnim, KennethMustDie.winCapCountUp], {
            duration: 0.3,
            alpha: 1
        }, 0);
        tl.add([
            () => {
                this._clickCallback = cb;
                KennethMustDie.keypadPlugin.setWin(0);

                this._countUpAnim.visible = true;
                this._countUpAnim.state.setAnimation(0, "animation", true);

                KennethMustDie.winCapCountUp.stopAt(0);
                KennethMustDie.winCapCountUp.preCalculateScale(0, winAmount);
                KennethMustDie.winCapCountUp.getReady(510);

                KennethMustDie.blackBg.show(1);

                KennethMustDie.soundPlayer.playSound(KMDSound.WIN_CAP_COUNT_UP);
                KennethMustDie.soundPlayer.fadeMusic({
                    name: "",
                    duration: 100,
                    to: 0
                });
            },
            KennethMustDie.winCapCountUp.getCountAnimation(0, winAmount, duration)
        ], 0);

        tl.add(() => {
            KennethMustDie.winCapCountUp.stopAt(winAmount);
            KennethMustDie.setKeypadWin(useTotalWin);

            // #249, #500
            KennethMustDie.soundPlayer.playSound(KMDSound.WIN_CAP_TOTAL_SUM_HIT);
        });
        tl.to(this, {
            duration: switchDuration
        });
        tl.addLabel("doSwitch");

        tl.to([this._countUpAnim, KennethMustDie.winCapCountUp], {
            duration: switchDuration,
            alpha: 0
        }, "doSwitch");
        tl.add(() => {
            this._animBg.alpha = this._anim.alpha = this._oldFilm.alpha = this._winTimesContainer.alpha = 0;

            this._animBg.visible = true;
            this._anim.visible = true;
            this._winTimesContainer.visible = true;

            this._oldFilm.visible = true;
            this._oldFilm.state.setAnimation(0, "animation", true);
        }, "doSwitch");
        tl.to([this._animBg, this._anim, this._oldFilm, this._winTimesContainer], {
            duration: switchDuration,
            alpha: 1
        }, "doSwitch");

        tl.add(() => {
            this._countUpAnim.visible = false;
            this._countUpAnim.state.clearTracks();
            KennethMustDie.winCapCountUp.visible = false;

            this._countUpAnim.alpha = KennethMustDie.winCapCountUp.alpha = 1;

            this.animateBeefy();
            this.animateWinTimesX();

            this._button.alpha = 0;
            this._button.visible = true;

            // #500
            KennethMustDie.soundPlayer.playSound(KMDSound.WIN_CAP_LOOP, 1, Number.MAX_VALUE);
        });
        tl.to(this._button, {
            duration: switchDuration,
            alpha: 1
        });
        tl.add(() => {
            this._button.enable(true);
        });
    }

    private init(): void {
        this._countUpAnim = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("winCapCountUp"));
        this._countUpAnim.visible = false;
        this._countUpAnim.position.set(360);

        this._animBg = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("winCapBg"));
        this._animBg.visible = false;
        this._animBg.position.set(360);

        this._anim = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("winCap"));
        this._anim.visible = false;
        this._anim.scale.set(0.81);
        this._anim.position.set(374.22, 240);

        this._oldFilm = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("winCapOldFilm"));
        this._oldFilm.visible = false;
        this._oldFilm.position.set(360);

        this._winTimesXLeft = new PIXI.BitmapText("", {
            fontName: KMDGameAssets.BITMAP_FONT_WIN_CAP,
            fontSize: 30
        });
        this._winTimesXLeft.anchor = new PIXI.Point(0.5, 0.5);

        const winTimesXRight: PIXI.BitmapText = new PIXI.BitmapText("000x", {
            fontName: KMDGameAssets.BITMAP_FONT_WIN_CAP,
            fontSize: 32
        });
        winTimesXRight.anchor = new PIXI.Point(0.5, 0.5);
        winTimesXRight.position.set(70, 0);

        this._winTimesContainer = new PIXI.Container();
        this._winTimesContainer.visible = false;
        this._winTimesContainer.addChild(this._winTimesXLeft, winTimesXRight);
        this._winTimesContainer.position.set(338, 483);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();
        });
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this._button.visible = false;
        this.onResize();

        this.addChild(this._countUpAnim, this._animBg, this._anim, this._oldFilm, this._winTimesContainer, this._button);
    }

    private animateBeefy(): void {
        this._beefyDanceTl = gsap.timeline();

        this._beefyDanceTl.add([
            KennethMustDie.createTimelineForAnimation(this._animBg, 0, "animation", false).repeat(3),
            KennethMustDie.createTimelineForAnimation(this._anim, 0, "animation", false).repeat(3)
        ]);
        this._beefyDanceTl.add([
            KennethMustDie.createTimelineForAnimation(this._animBg, 0, "animation3", false).repeat(3),
            KennethMustDie.createTimelineForAnimation(this._anim, 0, "animation3", false).repeat(3)
        ]);
        this._beefyDanceTl.add([
            KennethMustDie.createTimelineForAnimation(this._animBg, 0, "animation", false).repeat(3),
            KennethMustDie.createTimelineForAnimation(this._anim, 0, "animation", false).repeat(3)
        ]);
        this._beefyDanceTl.add([
            KennethMustDie.createTimelineForAnimation(this._animBg, 0, "animation3", false).repeat(3),
            KennethMustDie.createTimelineForAnimation(this._anim, 0, "animation3", false).repeat(3)
        ]);
        this._beefyDanceTl.timeScale(2);
        this._beefyDanceTl.add(() => {
            this.animateBeefy();
        });
    }

    private animateWinTimesX(): void {
        this._winTimesTl = gsap.timeline();

        this._winTimesTl.to(this._winTimesContainer.scale, {
            duration: 0.5,
            x: 0.941,
            y: 0.941
        });
        this._winTimesTl.to(this._winTimesContainer.scale, {
            duration: 0.6,
            x: 1.048,
            y: 1.048
        });
        this._winTimesTl.to(this, {
            duration: 0.17
        });

        this._winTimesTl.timeScale(2);

        this._winTimesTl.add(() => {
            this.animateWinTimesX();
        });
    }

    private onButtonClick(): void {
        KennethMustDie.backgroundElements.setMode(KMDGameMode.NORMAL);

        this._button.enable(false);

        const tl: gsap.core.Timeline = gsap.timeline(),
            duration: number = 0.5;

        this._beefyDanceTl.pause();
        this._beefyDanceTl.kill();
        this._winTimesTl.pause();
        this._winTimesTl.kill();

        // #500
        KennethMustDie.soundPlayer.stopSound(KMDSound.WIN_CAP_LOOP);
        KennethMustDie.soundPlayer.playSound(KMDSound.WIN_CAP_BTN);
        KennethMustDie.soundPlayer.fadeMusic({
            name: "",
            duration: 100,
            to: 1
        });

        tl.add(KennethMustDie.returnToMainGame(duration), 0);
        tl.to([this._animBg, this._anim, this._oldFilm, this._winTimesContainer, this._button], {
            duration: duration,
            alpha: 0
        }, 0);

        tl.add(() => {
            this._animBg.visible = false;
            this._anim.visible = false;
            this._oldFilm.visible = false;
            this._winTimesContainer.visible = false;
            this._button.visible = false;

            this._oldFilm.state.clearTracks();

            this._animBg.alpha = this._anim.alpha = this._oldFilm.alpha = this._winTimesContainer.alpha = this._button.alpha = 1;

            this._clickCallback();
        });
    }
}